/**
 * Firebase collection names for workflow data
 */
export const COLLECTIONS = {
  // Old Collections (kept for backward compatibility)
  WORKFLOW_REFERENCES: 'workflow_references',
  WORKFLOW_STAGES: 'workflow_stages',
  DOCUMENT_REVISIONS: 'document_revisions',
  AUDIT_LOGS: 'audit_logs',
  
  // New simplified Collections
  WORKFLOWS: 'workflows',  // New main Collection for Workflows
  
  // Common Collections
  PAYMENTS: 'payments',
  INVOICES: 'invoices',
  OFFERS: 'offers'
};